import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { switchMap } from 'rxjs/operators';
import { UserService } from 'app/core/user/user.service';

@Injectable({
    providedIn: 'root'
})
export class RoleGuard implements CanActivate, CanActivateChild, CanLoad {
    constructor(
        private _authService: AuthService,
        private _router: Router,
        private _userService: UserService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const redirectUrl = route.data.redirectTo ?? '/';
        let roles = route.data.roles as string[] ?? [];
        return this._check(redirectUrl, roles, route);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const redirectUrl = '/';
        let roles = childRoute.data.roles as string[] ?? [];
        return this._check(redirectUrl, roles, childRoute);
    }

    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        let roles = route.data.roles as string[] ?? [];
        return this._check('/', roles);
    }

    private _check(redirectURL: string, allowedRoles: string[], route?: ActivatedRouteSnapshot): Observable<boolean> {
        return combineLatest([this._authService.check(), this._userService.user$])
            .pipe(
                switchMap(([authenticated, user]) => {
                    if (!authenticated || !allowedRoles.includes(user.role)) {
                        console.log('RoleGuard: redirecting to ' + redirectURL);
                        console.log('RoleGuard: allowed roles: ' + allowedRoles);
                        console.log('RoleGuard: user role: ' + user.role);
                        console.log('RoleGuard: authenticated: ' + authenticated);
                        console.log('RoleGuard: route: ' + route);
                        this._router.navigate([redirectURL]);

                        // Prevent the access
                        console.warn('access denied');
                        return of(false);
                    }

                    if (!user.permissions.platformAccess) {
                        return of(false);
                    }

                    // Allow the access
                    return of(true);
                })
            );
    }
}
